
import Vue from 'vue'
import BankHistoryBlock from '../bank-history-block/bank-history-block.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'BankHistoryBlockList',
  components: { BankHistoryBlock },
  mixins: [staticBlockMixin]
})
